/**
 * Web has no OS review prompt — no-op. The trigger is already gated to mobile,
 * but we keep the stub so platform resolution stays consistent.
 */
export async function requestAppStoreReview(): Promise<void> {
  return Promise.resolve();
}
